/**
 * @fileoverview DELETE handler for the "/data_objects/:type_name/:external_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { customObjectsTypeNameExternalIdCacheKeys } from "./constants";
import type { DeleteCustomObjectsTypeNameExternalIdProps } from "./types";

export const deleteCustomObjectsTypeNameExternalId = reactQueryMutationAdapter(
  [...customObjectsTypeNameExternalIdCacheKeys],
  (props: DeleteCustomObjectsTypeNameExternalIdProps): Promise<Record<string, never>> => {
    return fetch(
      `/data_objects/${encodeURIComponent(props.typeName)}/${encodeURIComponent(props.externalId)}`,
      "DELETE",
      {},
      undefined,
      {
        propagateFetchRequestError: false,
      }
    );
  }
);
